module.exports = __webpack_public_path__ + "static/media/舵机转接模块.fe970fbf.png";